module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('div', {
    staticClass: "contact-page"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._m(0), _c('FooterMain')], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section thank-you"
  }, [_c('div', {
    staticClass: "section__container contact__content"
  }, [_c('div', {
    staticClass: "section__header contact__header"
  }, [_c('div', {
    staticClass: "section__header-title contact__header-title"
  }, [_c('h2', [_vm._v("Thanks for contacting us, We will reach you shortly.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d5c6c23"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/thank-you/thank-you.pug
// module id = 510
// module chunks = 1